import React, { useState, useEffect, useCallback } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';
import './header.scss';

export function Header() {
  const [state, setState] = useState({
    isMobileMenuOpen: false,
    isMobileServicesMenuOpen: false
  });
  const location = useLocation();

  useEffect(() => {
    setState({ isMobileMenuOpen: false, isMobileServicesMenuOpen: false });
  }, [location, setState, toggleMobileMenu]);

  const toggleMobileMenu = useCallback((event) => {
    event.preventDefault();

    setState(prevState => ({
      ...prevState,
      isMobileMenuOpen: !prevState.isMobileMenuOpen
    }));
  }, [setState]);

  const toggleMobileServicesMenu = useCallback((event) => {
    event.preventDefault();
    
    setState(prevState => ({
      ...prevState,
      isMobileServicesMenuOpen: !prevState.isMobileServicesMenuOpen
    }));
  }, [setState]);

  return (
    <header className="header__sticky">
      <div className="container">
        <div className="row">
          <div className="col-lg-3 col-6">
            <div id="logo_home">
              <h1>
                <Link to="/">
                  <i className="icon-stethoscope" />
                  Спортивный Диспансер
                </Link>
              </h1>
            </div>
          </div>
          <nav className="col-lg-9 col-6">
            <a
              className={`cmn-toggle-switch cmn-toggle-switch__htx open_close ${
                state.isMobileMenuOpen ? 'active' : ''
              }`}
              onClick={toggleMobileMenu}
              href=""
            >
              <span>Menu mobile</span>
            </a>
            <ul id="top_access" className="d-none">
              <li>
                <NavLink to="login.html">
                  <i className="pe-7s-user" />
                </NavLink>
              </li>
              <li>
                <NavLink to="register-doctor.html">
                  <i className="pe-7s-add-user" />
                </NavLink>
              </li>
            </ul>
            <div
              className={`main-menu ${state.isMobileMenuOpen ? 'show' : ''}`}
            >
              <ul>
                <li className="submenu">
                  <NavLink to="/">Главная</NavLink>
                </li>
                <li className="submenu">
                  <NavLink to="/administration">Администрация</NavLink>
                </li>
                <li className="submenu">
                  <NavLink
                    to="/services"
                    className="show-submenu"
                  >
                    Платные услуги
                    <i className="icon-down-open-mini" onClick={toggleMobileServicesMenu} />
                  </NavLink>
                  <ul
                    className={
                      state.isMobileServicesMenuOpen ? 'show_normal' : ''
                    }
                  >
                    <li>
                      <HashLink to="/services#anchorMedicalServices">
                        Перечень медицинских услуг
                      </HashLink>
                    </li>
                    <li>
                      <HashLink to="/services#anchorPrices">
                        Прейскуранты
                      </HashLink>
                    </li>
                    <li>
                      <HashLink to="/services#anchorDescription">
                        Порядок оказания платных услуг
                      </HashLink>
                    </li>
                    <li>
                      <HashLink to="/services#anchorPaymentMethods">
                        Способы оплаты
                      </HashLink>
                    </li>
                  </ul>
                </li>
                <li className="submenu">
                  <NavLink to="/schedule">График работы</NavLink>
                </li>
                <li className="submenu">
                  <NavLink to="/career">Вакансии</NavLink>
                </li>
                <li className="submenu">
                  <NavLink to="/about-us">О нас</NavLink>
                </li>
              </ul>
            </div>
          </nav>
        </div>
      </div>
    </header>
  );
}

export default Header;
